import { styled } from '@mui/material/styles';
import { mobileThreshold, portfolioBackground, portfolioWidth } from '../../Constants/layoutValues';

export const ProjectOverviewWrapper = styled('div')`
	background-color: ${portfolioBackground};
	color: #fff;
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: flex-start;
	margin-top: 0;
	max-width: calc(100vw - 4rem);
	min-width: calc(100vw - 4rem);
	width: calc(100vw - 4rem);
	flex-grow: 1;
	padding-top: 1rem;
	padding-bottom: 2rem;
	position: relative;
	padding-left: 2rem;
	padding-right: 2rem;
	@media (max-width: ${mobileThreshold}px) {
		padding-left: 0.5rem;
		padding-right: 0.5rem;
		padding-top: 2rem;
		max-width: calc(100vw - 1rem);
		min-width: calc(100vw - 1rem);
		width: calc(100vw - 1rem);
	}
	@media print {
		background-color: #fff;
		color: #000;
		align-items: flex-start;

		max-width: 100%;
		min-width: auto;
		width: 100%;

		/* Let it expand naturally top to bottom */
		flex-grow: unset;
		padding: 0;

		/* Ensure document flow isn’t constrained */
		display: block;
		position: static;
	}
`;

export const ProjectOverviewContentWrapper = styled('div')`
	// max-width: ${portfolioWidth};
	//width: 100%;
	display: flex;
	flex-direction: column;
`;

export const ProjectOverviewSection = styled('div')`
	padding-bottom: 1rem;
	@media print {
		padding-bottom: 0.5rem;
	}
`;

export const ProjectOverviewSectionTitle = styled('div')`
	font-family: spacemono;
	padding-bottom: 0.25rem;
`;

export const ProjectOverviewSectionBullets = styled('div')`
	padding-left: 1rem;
	@media print {
		padding-left: 0.5rem;
	}
`;

export const SubsectionWrapper = styled('div')`
	//padding-bottom: .75rem;
`;

export const SubsectionTitle = styled('div')`
	font-family: montserratSemiBold;
`;

export const SubsectionBulletWrapper = styled('div')`
	padding-bottom: 0.25rem;
`;

export const ProjectsWrapper = styled('div')`
	padding-left: 1rem;
	@media print {
		padding-left: 0.5rem;
	}
`;

export const ProjectWrapper = styled('div')`
	padding-top: 0.25rem;
	padding-bottom: 0.25rem;
	:first-of-type {
		padding-top: 0;
	}
	@media print {
		padding-top: 0.1rem;
		padding-bottom: 0.1rem;
		:first-of-type {
			padding-top: 0rem;
		}
	}
`;

export const ProjectTitle = styled('div')``;

export const ProjectContent = styled('div')`
	padding-left: 0rem;
`;

export const BulletsWrapper = styled('ul')`
	margin-top: 0;
	margin-bottom: 0;
	padding-left: 1rem;
	padding-bottom: 0.25rem;
	@media print {
		padding-left: 0.75rem;
		margin-top: 0;
		margin-bottom: 0;
		padding-top: 0;
		padding-bottom: 0.25rem;
	}
`;

export const BulletWrapper = styled('li')``;

export const BulletTools = styled('div')`
	font-family: montserratItalics;
`;

export const ToolsWrapper = styled('div')`
	font-family: montserratItalics;
	display: flex;
	font-weight: 100;
	font-size: 0.85em;
	padding-left: 0;
	//font-style: italic;
	line-height: 1.5;
	flex-direction: row;
	@media print {
		//padding-top: 0.1em;
		//font-size: 0.8em;
	}
`;

export const ToolsTitleWrapper = styled('div')`
	padding-left: 1rem;
	padding-right: 0.5rem;
	@media print {
		padding-left: 0.5rem;
	}
`;
